import { Chip } from 'vnetwork-ui'
import { ServiceUsageTemplateAPI } from '../../types'
import dayjs from 'dayjs'
import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'

const columns: GridColDefVNW<ServiceUsageTemplateAPI>[] = [
    {
        field: 'service_usage_template_api_id',
        headerName: 'ID',
        width: 80,
        sortable: true,
    },
    {
        field: 'name',
        headerName: 'Name',
        width: 200,
        sortable: true,
        renderCell: ({ value }) => (
            <span className="font-medium text-gray-900">{value}</span>
        ),
    },
    {
        field: 'method',
        headerName: 'Method',
        width: 100,
        sortable: true,
        renderCell: ({ value }) => {
            const colorMap = {
                GET: 'success',
                POST: 'warning',
                PUT: 'info',
                DELETE: 'error',
            } as const

            return (
                <Chip
                    color={colorMap[value as keyof typeof colorMap]}
                    label={value}
                    size="small"
                    variant="contained"
                />
            )
        },
    },
    {
        field: 'url',
        headerName: 'URL',
        width: 1200,
        sortable: false,
        renderCell: ({ value }) => value,
    },
    {
        field: 'timeout_seconds',
        headerName: 'Timeout (s)',
        width: 120,
        sortable: true,
        renderCell: ({ value }) => (
            <span className="text-sm text-gray-600">{value}s</span>
        ),
    },
    {
        field: 'retry_count',
        headerName: 'Retry Count',
        width: 200,
        sortable: true,
        renderCell: ({ value }) => (
            <span className="text-sm text-gray-600">{value}</span>
        ),
    },
    {
        field: 'created_at',
        headerName: 'Created',
        width: 310,
        sortable: true,
        renderCell: ({ value }) => (
            <span className="text-sm text-gray-600">
                {dayjs(value).format('DD/MM/YYYY HH:mm')}
            </span>
        ),
    },
]

export default columns
